import React from 'react';
import { PageHeader } from '../components/dashboard/PageHeader';
import { Card, CardContent, CardHeader, CardTitle } from '../components/Card';
import { Bot, Users, Share2, AlertCircle, Globe, FileSearch, ExternalLink } from 'lucide-react';
import { Button } from '../components/Button';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '../components/Table';
import { Badge } from '../components/Badge';
import { BarChart, Bar, XAxis, YAxis, Tooltip as RTooltip, ResponsiveContainer } from 'recharts';
import { ChartContainer, ChartTooltipContent } from '../components/Chart';
import { toast } from 'sonner';
import { RelatedWorkflow } from '../components/dashboard/RelatedWorkflow';
const campaigns = [{
  id: 'CMP-2026-001',
  name: '#TolakKebijakanX',
  platform: 'X',
  bots: 1247,
  target: 'Kebijakan Pangan',
  start: '02:14 WIB',
  status: 'AKTIF',
  velocity: 'TINGGI'
}, {
  id: 'CMP-2026-002',
  name: '#BansosTidakAdil',
  platform: 'FB, X',
  bots: 892,
  target: 'Bansos Pangan',
  start: '04:00 WIB',
  status: 'AKTIF',
  velocity: 'TINGGI'
}, {
  id: 'CMP-2026-003',
  name: 'Operasi Disinfo Pajak',
  platform: 'TikTok',
  bots: 534,
  target: 'Pajak Hiburan',
  start: '08:22 WIB',
  status: 'MITIGASI',
  velocity: 'SEDANG'
}, {
  id: 'CMP-2026-004',
  name: '#BBMNaikDiamDiam',
  platform: 'X',
  bots: 412,
  target: 'BBM Subsidi',
  start: '06:45 WIB',
  status: 'MONITORING',
  velocity: 'RENDAH'
}, {
  id: 'CMP-2026-005',
  name: 'Spam Komentar IKN',
  platform: 'YT',
  bots: 287,
  target: 'IKN',
  start: '10:11 WIB',
  status: 'TAKEDOWN',
  velocity: 'RENDAH'
}];
const platformData = [{
  platform: 'X',
  count: 4500
}, {
  platform: 'TikTok',
  count: 3200
}, {
  platform: 'FB',
  count: 2100
}, {
  platform: 'IG',
  count: 1800
}, {
  platform: 'YT',
  count: 950
}, {
  platform: 'Threads',
  count: 400
}];
const config = {
  count: {
    label: 'Bot',
    color: 'hsl(var(--destructive))'
  }
};
const statusColor: Record<string, string> = {
  AKTIF: 'bg-red-500/10 text-red-500',
  MITIGASI: 'bg-amber-500/10 text-amber-500',
  MONITORING: 'bg-blue-500/10 text-blue-500',
  TAKEDOWN: 'bg-emerald-500/10 text-emerald-500'
};
export function BotDetection() {
  return <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-6" data-id="element-1262">
      <PageHeader group="Intelijen Aktor" title="Buzzer & Bot Detection" description="Deteksi pola perilaku terkoordinasi lintas platform — bot, buzzer, dan kampanye amplifikasi." icon={Bot} data-id="element-1263" />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1264">
        {[{
        label: 'Bot Terdeteksi 24J',
        value: '12.9K',
        icon: Bot,
        color: 'text-red-500'
      }, {
        label: 'Buzzer Clusters',
        value: '42',
        icon: Users,
        color: 'text-amber-500'
      }, {
        label: 'Coordinated Campaigns',
        value: '8',
        icon: Share2,
        color: 'text-orange-500'
      }, {
        label: 'Akun Suspended',
        value: '3.4K',
        icon: AlertCircle,
        color: 'text-emerald-500'
      }].map(k => <Card key={k.label} className="bg-card border-border/50" data-id="element-1265">
            <CardContent className="p-4" data-id="element-1266">
              <div data-id="element-1267">
                <p className="font-mono text-[10px] uppercase text-muted-foreground" data-id="element-1268">
                  {k.label}
                </p>
                <p className={`font-heading text-2xl font-bold mt-1 ${k.color}`} data-id="element-1269">
                  {k.value}
                </p>
              </div>
              <k.icon className={`size-6 ${k.color}`} data-id="element-1270" />
            </CardContent>
          </Card>)}
      </div>

      <div className="grid grid-cols-12 gap-4" data-id="element-1271">
        <Card className="col-span-12 lg:col-span-8 bg-card border-border/50" data-id="element-1272">
          <CardContent className="p-4" data-id="element-1273">
            <div className="overflow-x-auto" data-id="element-1274">
              <Table data-id="element-1275">
                <TableHeader className="bg-muted/20" data-id="element-1276">
                  <TableRow className="border-border/50 hover:bg-transparent" data-id="element-1277">
                    <TableHead className="font-mono text-[9px]" data-id="element-1278">ID</TableHead>
                    <TableHead className="font-mono text-[9px]" data-id="element-1279">
                      KAMPANYE
                    </TableHead>
                    <TableHead className="font-mono text-[9px]" data-id="element-1280">
                      PLATFORM
                    </TableHead>
                    <TableHead className="font-mono text-[9px]" data-id="element-1281">BOT</TableHead>
                    <TableHead className="font-mono text-[9px]" data-id="element-1282">
                      TARGET
                    </TableHead>
                    <TableHead className="font-mono text-[9px]" data-id="element-1283">
                      VELOCITY
                    </TableHead>
                    <TableHead className="font-mono text-[9px]" data-id="element-1284">
                      STATUS
                    </TableHead>
                    <TableHead className="font-mono text-[9px] text-right" data-id="element-1285">
                      AKSI
                    </TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody data-id="element-1286">
                  {campaigns.map(c => <TableRow key={c.id} className="border-border/30 hover:bg-muted/10" data-id="element-1287">
                      <TableCell className="font-mono text-[10px] text-muted-foreground" data-id="element-1288">
                        {c.id}
                      </TableCell>
                      <TableCell className="text-xs font-bold" data-id="element-1289">
                        {c.name}
                      </TableCell>
                      <TableCell className="font-mono text-[10px]" data-id="element-1290">
                        {c.platform}
                      </TableCell>
                      <TableCell className="font-mono text-xs" data-id="element-1291">
                        {c.bots.toLocaleString('id-ID')}
                      </TableCell>
                      <TableCell className="text-xs text-muted-foreground" data-id="element-1292">
                        {c.target}
                      </TableCell>
                      <TableCell data-id="element-1293">
                        <span className={`font-mono text-[9px] ${c.velocity === 'TINGGI' ? 'text-red-500' : c.velocity === 'SEDANG' ? 'text-amber-500' : 'text-blue-500'}`} data-id="element-1294">
                          {c.velocity}
                        </span>
                      </TableCell>
                      <TableCell data-id="element-1295">
                        <Badge variant="outline" className={`font-mono text-[8px] px-1 py-0 h-4 border-none ${statusColor[c.status]}`} data-id="element-1296">
                          {c.status}
                        </Badge>
                      </TableCell>
                      <TableCell className="text-right" data-id="element-1297">
                        <Button size="xs" variant="outline" className="h-6 text-[9px] font-mono" onClick={() => toast.success(`Permintaan takedown ${c.id} dikirim ke platform`)} data-id="element-1298">
                          Takedown
                        </Button>
                      </TableCell>
                    </TableRow>)}
                </TableBody>
              </Table>
            </div>
          </CardContent>
        </Card>

        <Card className="col-span-12 lg:col-span-4 bg-card border-border/50" data-id="element-1299">
          <CardContent className="p-4 h-[380px]" data-id="element-1300">
            <ChartContainer config={config} className="h-full w-full" data-id="element-1301">
              <BarChart data={platformData} margin={{
              top: 10,
              right: 10,
              left: -20,
              bottom: 0
            }} data-id="element-1302">
                <XAxis dataKey="platform" stroke="hsl(var(--muted-foreground))" fontSize={10} tickLine={false} axisLine={false} data-id="element-1303" />
                <YAxis stroke="hsl(var(--muted-foreground))" fontSize={10} tickLine={false} axisLine={false} data-id="element-1304" />
                <RTooltip content={<ChartTooltipContent hideLabel data-id="element-1306" />} cursor={{
                fill: 'hsl(var(--muted)/0.5)'
              }} data-id="element-1305" />
                <Bar dataKey="count" fill="var(--color-count)" radius={[3, 3, 0, 0]} data-id="element-1307" />
              </BarChart>
            </ChartContainer>
          </CardContent>
        </Card>
      </div>

      <RelatedWorkflow currentStep="Deteksi Bot & Buzzer" nextSteps={[{
      to: '/actor-network',
      icon: Users,
      label: 'Aktor di Balik Klaster',
      desc: 'Petakan operator klaster bot ini.'
    }, {
      to: '/foreign-influence',
      icon: Globe,
      label: 'Cek Pengaruh Asing',
      desc: 'Cross-reference dengan server luar negeri.'
    }, {
      to: '/case-management',
      icon: FileSearch,
      label: 'Buat Berkas Kasus',
      desc: 'Buka kasus pelanggaran ITE untuk klaster ini.'
    }, {
      to: '/platform-reporting',
      icon: ExternalLink,
      label: 'Lapor ke Platform',
      desc: 'Permintaan takedown massal akun bot.',
      badge: 'EKSTERNAL'
    }]} data-id="element-1308" />
    </div>;
}